import request from "@/service";

/*班级作业列表*/
export function getClassWorkList(params) {
  return request({
    url: `/study/class/work/page`,
    method: "get",
    params
  });
}

/* 班级作业新增 */
export function saveClassWork(params) {
  return request({
    url: `/study/class/work/save`,
    method: "post",
    data: params
  });
}

/* 班级作业详情 */
export function getClassWorkInfo(uuid) {
  return request({
    url: `/study/class/work/info/${uuid}`,
    method: "get"
  });
}

/* 班级作业修改 */
export function updateClassWork(params) {
  return request({
    url: `/study/class/work/update`,
    method: "put",
    data: params
  });
}

/* 班级作业删除 */
export function deleteClassWork(params) {
  return request({
    url: `/study/class/work/delete`,
    method: "delete",
    data: params
  });
}
/* 班级作业附件下载 */
export function downloadWorkFile(params) {
  return request({
    url: `/study/class/work/download`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

/*班级学员作业列表*/
export function getStudentWorkList(params) {
  return request({
    url: `/study/class/studentWork/page`,
    method: "get",
    params
  });
}

/*班级学员作业上传*/
export function uploadWork(params) {
  return request({
    url: `/study/class/studentWork/uploadWork`,
    method: "post",
    data: params
  });
}

/* 班级作业下载 */
export function batchDownloadWork(params) {
  return request({
    url: `/study/class/studentWork/download`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

/*班级学员作业发消息*/
export function sendMessage(params) {
  return request({
    url: `/study/class/studentWork/sendMessage`,
    method: "post",
    data: params
  });
}
